<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { TooltipTrigger } from 'radix-vue';

interface Props {
    class?: HTMLAttributes['class'];
}

const props = defineProps<Props>();
</script>

<template>
    <tooltip-trigger v-bind="props">
        <slot />
    </tooltip-trigger>
</template>
